import { render, staticRenderFns } from "./IHAPlanChangeAgreementText.vue?vue&type=template&id=1d2f2b67&scoped=true&"
import script from "./IHAPlanChangeAgreementText.vue?vue&type=script&lang=js&"
export * from "./IHAPlanChangeAgreementText.vue?vue&type=script&lang=js&"
import style0 from "./IHAPlanChangeAgreementText.vue?vue&type=style&index=0&id=1d2f2b67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2f2b67",
  null
  
)

export default component.exports